export default __webpack_public_path__ + "static/media/1355.1ceab55e.png";